/**
 * Financial Management Routes
 *
 * Route definitions for the financial management module.
 */

import { lazy } from 'react';

const FinancialStatementDemo = lazy(() => import('./FinancialStatementDemo'));

export const financialStatementRoutes = [
    {
        path: 'financial-statements',
        element: <FinancialStatementDemo />,
    },
];
